import React from 'react';

const Footer = () => {
  return (
    <footer className="footer fixed-footer">
      <div className="footer-fixed-content">
        <nav className="footer-fixed-links">
          <a href="#empresa">EMPRESA</a>
          <a href="#productos">PRODUCTOS</a>
          <a href="#servicios">SERVICIOS</a>
          <a href="#procesos">PROCESOS</a>
          <a href="#clientes">CLIENTES</a>
          <a href="#contacto">CONTACTO</a>
        </nav>
        <div className="footer-fixed-meta">
          <span>© 2025 Soprano S.A. Todos los derechos reservados.</span>
          <a href="https://www.sopranografica.com.ar" target="_blank" rel="noopener noreferrer">www.sopranografica.com.ar</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
